import ChallengeSectionTimer from './ChallengeSectionTimer';
import { useTranslation } from '../../../../../translations';
import Icon from '../../../../baseComponents/gui/icon/Icon';

export default function ChallengeSectionProgress({ challengeData }) {
  const { t } = useTranslation();

  const { progress, triggerCount } = challengeData;
  const progressText = t('other.progress', { current: progress, total: triggerCount });

  return (
    <>
      <div className={'challenges__section-header-arrow'}>
        <Icon name={'challenges/arrow'} />
      </div>

      <div className={'challenges__section-progress'}>
        <div
          className={'challenges__section-progress-block'}
          style={{ '--progress': `${(progress / triggerCount) * 100}%` }}
        >
          <div className={'challenges__section-progress-line'} />

          <div className={'challenges__section-progress-counter'}>
            <div className={'challenges__section-progress-counter-item'}>
              <div className={'challenges__section-progress-counter-item-block'}>{progressText}</div>
            </div>
          </div>
        </div>

        <ChallengeSectionTimer challengeData={challengeData} />
      </div>
    </>
  );
}
